import React, { useState, useEffect, Suspense } from "react";
import { CandidateContext } from "./CandidateContext";
import {
  Navigate,
  Route,
  Routes as CandidateRoutes,
  useLocation
} from "react-router-dom";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import useWindowDimensions from "../../hooks/useWindowSize";
import { useSelector } from "react-redux";
//ROUTES
import Assessment from "./assessments/Assessment";
import Dashboard from "./dashboard/Dashboard";
import Documentation from "./documentation/Documentation";
import ExamHistory from "./examHistory/ExamHistory";
import Settings from "./settings/Settings";
import Notifications from "./notifications/Notifications";
import Profile from "./profile/Profile";
import { pageRoutes } from "../../PageRoutes";
import FeedBack from "./FeedBack";
import NotFoundPage from "../../components/404Page/NotFoundPage";
import NoAccess from "./../../noAccess";
import Redirect from "./dashboard/Redirect";
import { useDispatch } from "react-redux";
import { updateProfileStatus } from "../../features/candidate-exam/candidate-exam-slice";
import Application from "./applications/Application";
import Result from "./result/Result";
import Loader from "../../components/loader/Loader";
import TranslationLoader from "../../components/TranslationLoader";
import ViewAssessment from "../joinExam/ViewAssessments";

const CandidateRoutes_ = () => {
  const [candidateContext, setCandidateContext] = useState({});
  const [showProfileModal, setShowProfileModal] = useState(false)
  const [isOpen, setIsOpen] = useState(
    //hide sidebar in mobile by default
    window.matchMedia("(max-width: 700px)").matches ? false : true
  );
  const [currentPageID, setCurrentPageID] = useState(0);
  const { width } = useWindowDimensions();
  const location = useLocation();
  const disabled = process.env.REACT_APP_DISABLE_ROUTE;
  const { profileComplete } = useSelector((state) => state.candidateExam);
  const dispatch = useDispatch()

  const toggleSidebar = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const setSelectedPageID = (id) => {
    setCurrentPageID(id);
  };

  const standaloneExam = sessionStorage.getItem("view");
  const userData = sessionStorage.getItem("user");

  useEffect(() => {
    dispatch(updateProfileStatus(false))
  }, [])

  useEffect(() => {
    if (
      !location.pathname.includes("candidate-assessment") &&
      standaloneExam !== "viewStandaloneExam"
    ) {
      const sideBar = document.querySelector("#sidebar")
      if (sideBar) {
        sideBar.style.display = "flex";
        if (window.matchMedia("(max-width: 700px)").matches) {
          document.querySelector(".mobile-navbar").style.display = "block";
        }
      }
    }
    // disabled forcing candidate to update profile
    /*if(userData !== null){
      if(!location.pathname.includes('/candidate/profile') && !profileComplete){
        const userProfileCompleted = JSON.parse(userData)?.user?.profile_completion_status
        if(!userProfileCompleted) setShowProfileModal(true)
      }
    }*/
  }, [location.pathname]);

  return (
    <React.Fragment>
      {width < 768 && (
        <Header sidebarToggle={toggleSidebar} windowWidth={width} />
      )}
      <div className="flex layout-wrapper">
        <TranslationLoader>
          <Sidebar
            pages={pageRoutes}
            setPage={setSelectedPageID}
            currentPage={currentPageID}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            windowWidth={width}
          />
        </TranslationLoader>
        <div
          className="p-2 md:p-5"
          id="parent-container"
          style={{
            flex: "4",
            backgroundColor: "#f2f3f7",
            height: width < 768 ? "calc(100vh - 43px)" : "100vh",
            overflowY: "scroll",
          }}
        >
          {showProfileModal ?
            <Redirect
              handleRedirect={setShowProfileModal}
              title={`
                Your profile is incomplete, 
                Please update your profile and save your changes to proceed`
              }
              btnTitle={'Update My Profile'}
              to={'/candidate/profile'}
            />
            : null}
          <CandidateContext.Provider
            value={{ candidateContext, setCandidateContext }}
          >
            <CandidateRoutes>
              <Route
                path="/"
                element={<Navigate to={"/candidate/dashboard"} />}
              />
              <Route
                path="/dashboard"
                element={
                  disabled === "disable-route" ? (
                    <NoAccess />
                  ) : (
                    <Suspense fallback={<Loader />}>
                      <Dashboard />
                    </Suspense>
                  )
                }
              />
              <Route
                path="/assessments/*"
                element={<Assessment isOpen={isOpen} setIsOpen={setIsOpen} />}
              />
              <Route
                path="/join-exam/assessments/"
                element={<TranslationLoader>
                  <ViewAssessment />
                </TranslationLoader>}
              />
              <Route path="/documentation" element={<Documentation />} />
              {/* <Route path="/application" element={<TranslationLoader><Application /></TranslationLoader>} /> */}
              <Route path="/exam-history" element={<TranslationLoader><ExamHistory /></TranslationLoader>} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/results/:id" element={<TranslationLoader><Result /></TranslationLoader>} />
              {/* <Route path="/settings" element={<TranslationLoader><Settings /></TranslationLoader>} /> */}
              <Route path="/profile" element={disabled === "disable-route" ? <NoAccess /> : <TranslationLoader><Profile /></TranslationLoader>} />
              {/* <Route path="/profile/:uid1/:uid2" element={disabled === "disable-route" ? <NoAccess />: <Profile />} /> */}
              <Route path="/feedback" element={<FeedBack />} />
              {/*  404 page  */}
              <Route
                path="*"
                element={<NotFoundPage url={"/candidate/dashboard"} />}
              />
            </CandidateRoutes>
          </CandidateContext.Provider>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CandidateRoutes_;
